import { useEffect, useState } from 'react'

/** O relógio da tela, para os "há N s" andarem sem nova consulta. */
export function useAgora(passoMs = 1_000): number {
  const [agora, setAgora] = useState(() => Date.now())
  useEffect(() => {
    const t = setInterval(() => setAgora(Date.now()), passoMs)
    return () => clearInterval(t)
  }, [passoMs])
  return agora
}
